import { withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";

export const Accordion = withStyles({
  root: {
    boxShadow: "none",
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

export const AccordionSummary = withStyles({
  root: {
    cursor: "default !important",
    minHeight: 74,
    padding: "2px 16px",
    "&$expanded": {
      minHeight: 74,
    },
  },
  content: {
    justifyContent: "space-between",
    alignItems: "center",
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

export const AccordionDetails = withStyles(() => ({
  root: {
    backgroundColor: "#f8f9fb",
    borderTop: "1px solid #e8eaf0",
    padding: "0 16px",
    display: "block",
  },
}))(MuiAccordionDetails);
